import { createFocusTrap } from "focus-trap";
import bodyOverflow from "./utils/body-overflow";

const { on, trigger } = window.ivent;
const { body } = document;
const { getComputedStyle } = window;

const popupMap = new Map();
let zIndex = 0;
let hasShowPopup = true;

function updatePopupMap(popupId, data) {
	popupMap.set(popupId, {
		...popupMap.get(popupId),
		...data,
	});
}

function showPopup(popupId) {
	const { popup, popupDuration, focusTrap, popupIndex, hideTimeout } = popupMap.get(popupId);

	// Show.
	popup.classList.remove('popup-hide');
	popup.classList.add('popup-open');

	// Focus trap.
	const focusTimeout = setTimeout(() => {
		focusTrap?.activate();
	}, popupDuration / 2);

	// z-index.
	clearTimeout(hideTimeout);
	zIndex += 1;
	popup.style.setProperty('z-index', popupIndex + zIndex);

	updatePopupMap(popupId, { show: true, focusTimeout });
	bodyOverflow();
}

function hidePopup(popupId, data) {
	const { popup, popupDuration, focusTrap, focusTimeout } = data;

	popup.classList.remove('popup-open');
	popup.classList.add('popup-hide');

	// Deactivate focus trap.
	clearTimeout(focusTimeout);
	focusTrap?.deactivate();

	// Remove z-index.
	const hideTimeout = setTimeout(() => {
		popup.style.setProperty('z-index', '');
	}, popupDuration);

	updatePopupMap(popupId, { show: false, hideTimeout });
}

function onHidePopup(popupId) {
	if (!popupMap.size) return;

	hasShowPopup = false;

	// Hide visible popup.
	if (popupId) {
		hidePopup(popupId, popupMap.get(popupId));

		popupMap.forEach(({ show }) => {
			if (show) hasShowPopup = true;
		});

	// Hide all popups.
	} else {
		popupMap.forEach((data, popupId) => {
			hidePopup(popupId, data);
		});
	}

	// Disable overflow when all popups are hidden.
	if (!hasShowPopup) {
		bodyOverflow(false);
		zIndex = 0;
	}
}

// Init and open popup.
on(document, 'click', '[href^="#popup"]', (e) => {
	e.preventDefault();
	const toggle = e.delegateTarget;
	const href = toggle.getAttribute('href');
	const popupId = href.slice(1);

	// Create popup.
	if (!popupMap.has(popupId)) {
		const popup = document.createElement('div');
		popup.dataset.id = popupId;
		popup.classList.add('popup', popupId);

		// Create content.
		const content = document.querySelector(href);
		const newContent = document.createElement('div');
		newContent.className = content.className;
		newContent.innerHTML = content.innerHTML;

		// Append popup.
		popup.append(newContent);
		body.append(popup);
		popup.offsetHeight;

		const computedStyle = getComputedStyle(popup);

		popupMap.set(popupId, {
			popup,
			popupDuration: parseFloat(computedStyle.transitionDuration) * 1000,
			popupIndex: parseFloat(computedStyle.zIndex),
			content: newContent,
			focusTrap: createFocusTrap(popup),
			focusTimeout: null,
			hideTimeout: null,
			hasShow: true,
		});

		trigger(document, 'onInitPopup', { popup, content: newContent });
	}

	showPopup(popupId);
});

// Hide popup.
on(document, 'click', '.popup', (e) => {
	if (e.target === e.delegateTarget) {
		onHidePopup(e.delegateTarget.getAttribute('data-id'));
	}
});

on(document, 'click', '.popup-close', (e) => {
	onHidePopup(e.delegateTarget.closest('.popup').getAttribute('data-id'));
});

on(document, 'keyup', (e) => {
	if (e.key === 'Escape') onHidePopup();
});

on(document, 'onRenderPage', () => {
	onHidePopup();
});
